const isProductionEnv = () => process.env.NODE_ENV === 'production';

export {
  isProductionEnv,
};
